function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  fillOpacity: 0.05,
  cx: 16,
  cy: 16,
  r: 16
});

var _ref3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  gradientUnits: "userSpaceOnUse",
  x1: 5,
  y1: 28,
  x2: 17,
  y2: 16
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ff5c39"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#485cc7"
}));

var _ref4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "i",
  gradientUnits: "userSpaceOnUse",
  x1: 5,
  y1: 28,
  x2: 17,
  y2: 16
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopOpacity: 0.1
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "flame",
  fill: "url(#i)",
  d: "M7.174 12.066.006 16.266c.104 6.341 3.894 11.782 9.323 14.277L15.597 26.872V16.928L7.174 12.066z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "arrow",
  d: "M7.174 12.066 15.597 16.931v9.941l14.33-18.764z"
});

var SvgProca = function SvgProca(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProca, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Proca.07c78e78.svg";
export { ForwardRef as ReactComponent };